import React from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { Paper as MuiPaper } from '@mui/material'
import { darkTheme, lightTheme } from '../theme'

export default function Paper(props) {
  const { width, height, children, sx, ...other } = props

  const darkMode = useMediaQuery('(prefers-color-scheme: dark)', { noSsr: true })
  const theme = darkMode ? createTheme(darkTheme()) : createTheme(lightTheme())

  const styles = {
    border: '1px solid #dfdfdf',
    borderRadius: '26px',
    width: width,
    height: height,
    cursor: other.onClick && 'pointer',
    ...sx
  }

  return (
    <ThemeProvider theme={theme}>
      <MuiPaper elevation={0} sx={styles} {...other}>
        {children}
      </MuiPaper>
    </ThemeProvider>
  )
}
